import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader } from "@googlemaps/js-api-loader";
import { isDevHost } from "@helium10/re-core";
import { media } from "@helium10/re-ui-components";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { GOOGLEMAPS_KEY } from "../const/params";
import { GoogleAutocompleteStyle, Input } from "../Styles";
import { getPlaceDetails } from "../utils/getPlaceDetails";
const autocompleteObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === "attributes" &&
            mutation.target.getAttribute("autocomplete") === "off") {
            mutation.target.setAttribute("autocomplete", "section-address street-address");
        }
    });
});
export const StreetInput = ({ setValue, ...restProps }) => {
    const [googlePlaces, setGooglePlaces] = useState(null);
    const autoCompleteRef = useRef(null);
    const inputRef = useRef(null);
    useEffect(() => {
        autocompleteObserver.observe(inputRef.current, { attributes: true });
        return () => autocompleteObserver.disconnect();
    }, []);
    useEffect(() => {
        new Loader({ apiKey: GOOGLEMAPS_KEY, libraries: ["places"] })
            .importLibrary("places")
            .then(setGooglePlaces);
    }, [setGooglePlaces]);
    useEffect(() => {
        const isDev = isDevHost();
        if (inputRef.current && googlePlaces && !isDev) {
            const Autocomplete = googlePlaces?.Autocomplete;
            autoCompleteRef.current = new Autocomplete(inputRef.current, { types: ["geocode"] });
            if (autoCompleteRef.current) {
                autoCompleteRef.current.setFields(["address_component"]);
                autoCompleteRef.current.addListener("place_changed", async () => {
                    const place = await autoCompleteRef.current?.getPlace();
                    const placeOptions = getPlaceDetails({ place });
                    for (const [key, value] of Object.entries(placeOptions)) {
                        setValue(key, value ?? "", { shouldValidate: true });
                    }
                });
            }
        }
    }, [googlePlaces, setValue]);
    return (_jsxs(_Fragment, { children: [_jsx(StyledInput, { ...restProps, ref: inputRef }), _jsx(GoogleAutocompleteStyle, {})] }));
};
const StyledInput = styled(Input) `
  position: relative;

  ${media.desktopBefore} {
    min-width: 100%;
  }
`;
